import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { faBoxArchive } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CustomField } from 'types/domain';

interface TicketRemoveCustomFieldAlertProps extends AlertDialog.AlertDialogRootProps {
    customField: CustomField | null;
    onConfirm: () => void;
}

const TicketRemoveCustomFieldAlert = (props: TicketRemoveCustomFieldAlertProps) => {
    const { customField, onConfirm, children, ...rest } = props;

    if (!customField) {
        return children ? <>{children}</> : null;
    }

    return (
        <AlertDialog.Root type={'error'} {...rest}>
            <AlertDialog.Trigger asChild>{children}</AlertDialog.Trigger>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header className={'!items-start'}>
                        <div
                            className={
                                'relative flex aspect-square h-8 items-center justify-center rounded-full bg-red-500 text-white after:absolute after:-inset-1 after:-z-[1] after:rounded-full after:bg-red-100 after:p-2'
                            }
                        >
                            <FontAwesomeIcon icon={faBoxArchive} className={'text-lg text-white'} />
                        </div>
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title className={'text-xl'}>
                            Archive custom field?
                        </AlertDialog.Title>
                        <AlertDialog.Description>
                            Upon updating your ticket, <b>{customField.title}</b> will be archived
                            and no longer display the field or existing responses{' '}
                            {customField.group ? 'for all tickets' : 'anywhere'}.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer className={'gap-x-4'}>
                        <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action onClick={() => onConfirm()}>Archive</AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export { TicketRemoveCustomFieldAlert };
